import FormFeeItem from './form_fee_item';

const CustomFeeItem = FormFeeItem.extend({});

export default CustomFeeItem;
